/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect } from 'react';

export const termsOfUse = `
## TERMOS E CONDIÇÕES GERAIS DE USO DO APLICATIVO VIVAVOZ

Os serviços do aplicativo são fornecidos pela Rede Suco de Laranja e pela Rede Vidaviva, consórcio sindical das entidades que aderem a este aplicativo, titular da propriedade intelectual sobre software, aplicativos, conteúdos e demais ativos relacionados à plataforma VivaVoz enquanto permanecer membro destas redes.

---

## 1. Do objeto

A plataforma visa licenciar o uso de seu software, website, aplicativos e demais ativos de propriedade intelectual, fornecendo ferramentas para auxiliar e dinamizar o dia-a-dia dos seus usuários.

Com o objetivo de facilitar o acesso à comunicação e oferecimento de reclamações junto às entidades sindicais, o Consórcio da Rede Suco de Laranja e da Rede Vidaviva, através de seus sindicatos membros, disponibiliza gratuitamente o aplicativo VivaVoz, que permite acesso ao conteúdo do aplicativo.

A plataforma caracteriza-se pela prestação dos seguintes serviços:
- Envio de relatos sobre problemas nos locais de trabalho;
- Plataforma de notícias;
- Realização de pesquisa;
- Realizar sindicalização;
- Oferecer convênios aos associados das entidades que aderem a este aplicativo.

---

## 2. Da aceitação

O presente Termo estabelece obrigações contratadas de livre e espontânea vontade, por tempo indeterminado, entre a plataforma e as pessoas físicas e/ou jurídicas usuárias do aplicativo.

Ao utilizar a plataforma, o usuário aceita integralmente as presentes normas e compromete-se a observá-las, sob o risco de aplicação das penalidades cabíveis juridicamente.

A aceitação do presente instrumento é imprescindível para o acesso e utilização de quaisquer serviços fornecidos. Caso não concorde com as disposições deste instrumento, o usuário não deve utilizá-los.

---

## 3. Do acesso dos usuários

Serão utilizadas todas as soluções técnicas à disposição do responsável pela plataforma para permitir o acesso ao serviço 24 (vinte e quatro) horas por dia, 7 (sete) dias por semana. Contudo, a navegação poderá ser interrompida, limitada ou suspensa para atualizações ou qualquer ação necessária ao bom funcionamento.

---

## 4. Do cadastro

O acesso às funcionalidades da plataforma (notícias, convênios, solicitações de sindicalização) exigirá um cadastro prévio, exceto em casos de denúncias anônimas.

O usuário se compromete a fornecer dados válidos e atualizados, responsabilizando-se por mantê-los corretos. Também é responsável pela confidencialidade de suas informações de login e senha.

O cadastro implica na autorização para coleta, armazenamento e tratamento de informações conforme a Política de Privacidade.

---

## 5. Dos serviços ou produtos

A plataforma poderá disponibilizar um conjunto específico de funcionalidades e ferramentas para otimizar o uso dos serviços e produtos.

---

## 6. Política de Privacidade

A Política de Privacidade foi elaborada conforme a Lei 12.965/2014 (Marco Civil da Internet) e a Lei 13.709/2018 (LGPD).

Tratamos dados pessoais apenas para finalidades legítimas, específicas e determinadas, atualizando nossa política conforme a legislação.

---

## 9. Do suporte

Dúvidas, sugestões ou problemas devem ser encaminhados para: **redesucodelaranja@gmail.com**.

Atendimento de segunda a sexta, das 9h00 às 17h00.

---

## 10. Das responsabilidades

Responsabilidades do usuário:
- Defeitos ou vícios técnicos no próprio sistema;
- Correta utilização da plataforma;
- Cumprimento das regras deste termo;
- Proteção de seus dados de acesso.

Responsabilidades da plataforma:
- Informações corretas sobre os serviços/produtos;
- Responder por defeitos de serviços/produtos quando aplicável;
- Não se responsabilizar por links externos ou conteúdos ilícitos gerados por terceiros.

---

## 11. Dos direitos autorais

O uso da plataforma concede uma licença limitada, não exclusiva e intransferível para acessar os serviços.

Toda a propriedade intelectual relacionada é protegida por lei. O uso comercial ou não autorizado constitui infração de direitos.

---

## 12. Das sanções

A Rede Suco de Laranja poderá advertir, suspender ou cancelar contas de usuários que:
- Violarem os termos;
- Descumprirem seus deveres;
- Agirem de forma fraudulenta ou ofensiva.

---

## 13. Da rescisão

A violação dos termos ou da legislação aplicável poderá ensejar a rescisão imediata do serviço, sem aviso prévio.

---

## 14. Das alterações

Os termos poderão ser alterados unilateralmente para se adequar a mudanças nos serviços ou em exigências legais. O usuário poderá aceitar ou cancelar o uso após as alterações.

---

## 15. Do foro

Para a solução de controvérsias, será aplicado o Direito brasileiro, elegendo-se o foro de comarca definida entre as partes.

---
`;

const TermsOfUseScreen: React.FC = () => {
  useEffect(() => {
    document.title = 'Termos de Uso - VivaVoz';
    // não bloqueia o scroll global (layout em página)
  }, []);

  const publishedAt = '30 de abril de 2025'; // ajuste se quiser dinamizar

  const parseTermsOfUseToHtml = (text: string): string => {
    const lines = text.split('\n');
    return (
      lines
        .map(line => {
          if (line.startsWith('##')) {
            return `<h2 style="margin:28px 0 12px; font-size:22px; font-weight:700; text-align:left;">${line
              .replace('##', '')
              .trim()}</h2>`;
          }
          if (line.startsWith('---')) {
            return `<hr style="margin:28px 0; border:0; border-top:1px solid #e6e6e6;" />`;
          }

          if (line.trim() !== '') {
            return `<p style="margin:10px 0; line-height:1.8; color:#333;">${line.trim()}</p>`;
          }
          return '';
        })
        .join('')
        // junta <ul> consecutivos
        .replace(/<\/ul>\s*<ul/g, '')
    );
  };

  return (
    <div style={{ background: '#ffffff' }}>
      {/* HERO: gradiente claro com título e data */}
      <section
        style={{
          background:
            'linear-gradient(135deg,rgb(92, 247, 110) 0%,rgba(61, 157, 52, 0.56) 50%, #f3f0ff 100%)',
          padding: '56px 16px 64px',
          borderBottom: '1px solid #eee',
        }}
      >
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <h1
            style={{
              fontSize: 48,
              lineHeight: 1.1,
              margin: 0,
              fontWeight: 800,
              color: '#1d1d1f',
              letterSpacing: '-0.02em',
            }}
          >
            Termos de Uso
          </h1>
          <p
            style={{
              marginTop: 10,
              color: '#5f6368',
              fontSize: 14,
            }}
          >
            Publicado e vigente em: <strong>{publishedAt}</strong>
          </p>
        </div>
      </section>

      {/* CONTEÚDO: termos centralizados em largura confortável */}
      <section style={{ padding: '40px 16px 72px' }}>
        <div
          style={{
            maxWidth: 900,
            margin: '0 auto',
            color: '#1f2937',
            fontSize: 16,
          }}
        >
          <div
            style={{
              marginBottom: 24,
              borderBottom: '1px solid #eee',
              paddingBottom: 8,
            }}
          >
            <h2
              style={{
                fontSize: 20,
                margin: 0,
                fontWeight: 600,
                color: '#111827',
              }}
            >
              Bem-vindo ao VivaVoz
            </h2>
          </div>

          <div
            style={{
              textAlign: 'left',
              lineHeight: 1.8,
            }}
            dangerouslySetInnerHTML={{
              __html: parseTermsOfUseToHtml(termsOfUse),
            }}
          />
        </div>
      </section>
    </div>
  );
};

export default TermsOfUseScreen;
